import filteredUsers from '../response/users/search-all-users.json';
import me from '../response/users/me.json';
import meAdmin from '../response/users/me-admin.json';
import meV2 from '../response/users/me-v2.json';
import meAdminV2 from '../response/users/me-admin-v2.json';
import roles from '../response/users/roles.json';
import users from '../response/users/users-list.json';
import usersAdmin from '../response/users/users-list-admin.json';
import userAssignedAccounts from '../response/users/user-assigned-accounts.json';
import adminDetailedUser from '../response/users/user-admin-get-by-id.json';
import Env from 'Env';
import accountsForUser from '../response/users/account-get-accounts-for-user.json';

export default function UsersRoutes () {
  // Download Users
  this.get('users-api/v1/:clientId/users/download', () => {});

  // Search all Users
  this.get('/users-api/v1/users/search', () => filteredUsers);

  // My profile
  this.get('/users-api/v1/users/ME', () => {
    return Env.isAdminPortal() ? meAdmin : me;
  });

  // My profile
  this.get('/users-api/v2/users/ME', () => {
    return Env.isAdminPortal() ? meAdminV2 : meV2;
  });

  // Roles
  this.get('/users-api/v1/roles', () => roles);

  // Users List
  this.get('/users-api/v1/:accountId/users/search', () => users);

  // Admin Portal - Users List
  this.get('/users-api/v1/users', () => usersAdmin);

  // Admin Portal - Get User Assigned Accounts
  this.get('/users-api/v1/users/:userId/accountassignments', () => userAssignedAccounts);

  // Admin Portal - Remove account access for user
  this.delete('users-api/v1/users/:userId/accountassignments/:accountNumber', () => {});

  // Assign accounts to user
  this.put('/users-api/v1/:grandfatherClientNumber/users/:userId/accountassignments', () => {});

  // Admin Portal - Impersonate user
  this.post('/users-api/v1/users/:userId/impersonate', () => {});

  // Admin Portal - Get User by Id
  this.get('/users-api/v1/users/:userId', () => adminDetailedUser);

  // Admin Portal - Update user
  this.put('/users-api/v1/users/:userId', () => adminDetailedUser);

  // Admin Portal - Delete user
  this.delete('/users-api/v1/users/:userId', () => {});

  // Admin Portal - Get accounts for user
  this.get('accounts-api/v1/:userId/contracts/:accountNumber', () => accountsForUser);

  // Logout User
  this.post('/users-api/v1/users/logout', () => {});
}
